import { render } from "./SettingsList.vue?vue&type=template&id=595bd7ea&scoped=true"
import script from "./SettingsList.vue?vue&type=script&lang=js"
export * from "./SettingsList.vue?vue&type=script&lang=js"

import "./SettingsList.vue?vue&type=style&index=0&id=595bd7ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595bd7ea"]])

export default __exports__